// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ModalInstanceController {
   $scope: any
   $uibModalInstance: any
   constructor($scope: any, $uibModalInstance: any) {
      this.$scope = $scope
      this.$uibModalInstance = $uibModalInstance
      this.$scope.close = ($event: any) => {
         $event?.preventDefault()
         this.$uibModalInstance.dismiss('close')
         return this.$scope.closeCallback?.()
      }
   }
}

ModalInstanceController.$inject = ['$scope', '$uibModalInstance']

angular.module('summonApp.controllers')
   .controller('ModalInstanceCtrl', ModalInstanceController)
